var map = {
	"./logo_cars-4-sale.svg": "30b5",
	"./logo_fashion.svg": "3774",
	"./logo_groceries.svg": "375f",
	"./logo_grub-club.svg": "cb97",
	"./logo_holidayhub.svg": "355f",
	"./logo_nightlife.svg": "6511",
	"./logo_other-costs.svg": "a93b",
	"./logo_real-estate.svg": "2d00",
	"./logo_welcome.svg": "772c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8660";